import React, { Component } from "react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Grid from '@material-ui/core/Grid';

import Event from './modules/Event'
import './index.css';
import Utils from './modules/Utils';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      maxPeople: 100, // Max. počet lidí na akci  
      eventData:[], // Data Eventů pro rezervace

    }
  }
  // Iniciální načtení dat
  componentDidMount() {
    this.getEvents();
    //Poprvé hned aby se nečekalo v count
   
  }


  // Načtení pole osazenosti mše
  getEvents(){

    var formData = new FormData();
        formData.append('getEvents', true);
     
      let fetchData = { 
        method: 'POST', body: formData,      
        headers: {
           headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        },  
      }

    // A posílám
    fetch(Utils.getURL(), fetchData)   
    .then(response => response.json())
    .then(data => {          
        if ( data["success"]) {
        // Načtení data.data do tabulky
            if ( data["count"] > 0) {
              this.setState({eventData: data.data }); // Po přihlášení na hlavní stránku                    
            }
            else {
              this.setState({eventData: [] }); // Po přihlášení na hlavní stránku                    
            }        
        
        // console.log('Stav:', "OK");  
      }
        else{
          console.error('Chyba:', "Nejsou data");
              }            
    })
    .catch((error) => {
      console.error('Chyba:', error);
    });    
}


  render() { 
    return (
      <div >
        
        <AppBar position="sticky">
      {/* <AppBar position="static"> */}
                <Toolbar>
                  <IconButton edge="start" color="inherit" 
                    onClick={() => { 
                      window.location.href='http://augustinbrno.cz'; } }                                   
                      aria-label="menu">
                    <ArrowBackIcon />
                  </IconButton>
                  <Typography className="modulename" variant="h6" >
                  Bohoslužby
                  </Typography> 
                  <IconButton  color="inherit" 
                    onClick={() => { 
                        window.location.href='../help/SignIn.html';
                      } }                        
                    >
                    <HelpOutlineIcon/>
                  </IconButton>                    
                </Toolbar>
      </AppBar>
      <div class="info">
      Ministranti a děti do 2 let se nemusí přihlašovat.
      </div>
      
    <Grid container spacing={2}>
        {this.state.eventData.map((item, index) =>
          <Grid item xs={12} sm={6} md={4} lg={3} >                
            <Event myId ={item.event_id} myMax={item.event_max} 
            myName={item.event_name} 
            myComment={item.event_comment}
            >
            </Event>
        </Grid>
          )
        }

      </Grid> {/* Hlavní grid */}
      <br></br>
      <div class="info">
      <br></br><br></br>
      Tip: Na mobilu si můžete dát odkaz na aplikaci na plochu telefonu
      a odtud ji pak kdykoliv pohodně spouštět.
      V Chrome je to v menu "Přidat na plochu". 
      Ve Firefoxu v menu "Stránka-Přidat zkratku stránky".
      </div>
      <br></br><br></br><br></br><br></br><br></br>
      <br></br><br></br><br></br><br></br><br></br>
      <footer>
        <Typography variant="body2" color="textSecondary" align="center">
        { 'v1.05 Copyright © KAK 2020'}      
        </Typography>
        </footer>
      </div>
    );
  }
}

export default App;